import { styled, Tooltip, TooltipProps } from '@mui/material';

export const StyledInfoTooltip = styled(Tooltip)<TooltipProps>`
  font-size: 1.5rem;
`;
